import React from 'react';

const Users = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.66667 17.5V16.6667C6.66667 16.2246 6.84226 15.8007 7.15482 15.4882C7.46738 15.1756 7.89131 15 8.33333 15H11.6667C12.1087 15 12.5326 15.1756 12.8452 15.4882C13.1577 15.8007 13.3333 16.2246 13.3333 16.6667V17.5M14.1667 8.33333H15.8333C16.2754 8.33333 16.6993 8.50893 17.0118 8.82149C17.3244 9.13405 17.5 9.55797 17.5 10V10.8333M2.5 10.8333V10C2.5 9.55797 2.67559 9.13405 2.98816 8.82149C3.30072 8.50893 3.72464 8.33333 4.16667 8.33333H5.83333M8.33333 10.8333C8.33333 11.2754 8.50893 11.6993 8.82149 12.0118C9.13405 12.3244 9.55797 12.5 10 12.5C10.442 12.5 10.866 12.3244 11.1785 12.0118C11.4911 11.6993 11.6667 11.2754 11.6667 10.8333C11.6667 10.3913 11.4911 9.96738 11.1785 9.65482C10.866 9.34226 10.442 9.16667 10 9.16667C9.55797 9.16667 9.13405 9.34226 8.82149 9.65482C8.50893 9.96738 8.33333 10.3913 8.33333 10.8333ZM12.5 4.16667C12.5 4.60869 12.6756 5.03262 12.9882 5.34518C13.3007 5.65774 13.7246 5.83333 14.1667 5.83333C14.6087 5.83333 15.0326 5.65774 15.3452 5.34518C15.6577 5.03262 15.8333 4.60869 15.8333 4.16667C15.8333 3.72464 15.6577 3.30072 15.3452 2.98816C15.0326 2.67559 14.6087 2.5 14.1667 2.5C13.7246 2.5 13.3007 2.67559 12.9882 2.98816C12.6756 3.30072 12.5 3.72464 12.5 4.16667ZM4.16667 4.16667C4.16667 4.60869 4.34226 5.03262 4.65482 5.34518C4.96738 5.65774 5.39131 5.83333 5.83333 5.83333C6.27536 5.83333 6.69928 5.65774 7.01184 5.34518C7.3244 5.03262 7.5 4.60869 7.5 4.16667C7.5 3.72464 7.3244 3.30072 7.01184 2.98816C6.69928 2.67559 6.27536 2.5 5.83333 2.5C5.39131 2.5 4.96738 2.67559 4.65482 2.98816C4.34226 3.30072 4.16667 3.72464 4.16667 4.16667Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Users };
//# sourceMappingURL=Users.js.map
